// import classplusLogo from "../../../assets/Images/classplusLogo.png";
import classplusLogo from "../../assets/Images/classplusLogo.png";
import styles from "./Header.module.css";
import { useState, useEffect } from "react";
import { redirectWebinarPage } from "../../utils/redirectWebinarPage";
import trackEvent from "../utils";
// import trackEvent from "../utils"
const Header = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showButtn, setSHowButton] = useState(
    scrollPosition > 1000 ? true : false
  );
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleButtonClick = () => {
    redirectWebinarPage(
      "https://wa.me/919599448772?text=I%20want%20a%20free%20demo%20now",
      "Livebuttonnew"
    );
    trackEvent("redirectWebinar","click","bookFreeDemoHeader");
  };
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
    setSHowButton(position > 1000 ? true : false);
  };
  return (
    <nav className={styles.header}>
      <div className={styles.headerBox}>
        <img
          src={classplusLogo}
          alt="classplusLogo"
          className={styles.headerLogo}
          width="158px"
        />
        {true && (
          <button onClick={handleButtonClick}>I want a free demo now</button>
        )}
      </div>
    </nav>
  );
};
export default Header;
